import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Snowfall from './components/Snowfall';
import { IS_CHRISTMAS_SEASON } from './season';
import Home from './pages/Home';
import Servicios from './pages/Servicios';
import SobreNosotros from './pages/Nosotros';
import JMInversiones from './pages/JMInversiones';
import Contacto from './pages/Contacto';
import Solicitud from './pages/Solicitud';
import Solicitudinversiones from './pages/Solicitudinversiones'; 
import './App.css';

function App() {
  return (
    <Router>
      {IS_CHRISTMAS_SEASON && <Snowfall count={80} speed={1} />}
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/sobre-nosotros" element={<SobreNosotros />} />
          <Route path="/jm-inversiones" element={<JMInversiones />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/solicitud" element={<Solicitud />} />
          <Route path="/solicitud-inversiones" element={<Solicitudinversiones />} /> 
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;